import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TreeMultiSelectDialogComponent } from './tree-multi-select-dialog.component';
import { TreeMultiSelectModule } from 'clink-ui-x/tree-multi-select';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
    declarations: [TreeMultiSelectDialogComponent],
    imports: [CommonModule, TreeMultiSelectModule, FormsModule, NzGridModule, NzButtonModule],
    exports: [TreeMultiSelectDialogComponent],
})
export class TreeMultiSelectDialogModule {}
